import { useRouter } from 'next/router';
import { useTranslation } from 'react-i18next';
import { goToConversation, goToConversations, goToHome, pathnames } from 'utils/routerHelpers';
import { isAdmin } from 'utils/userHelpers';

import React from 'react';

import { ChatsCircle, UsersThree } from '@thinkific/chalk/react-icons';

import { useCommunityContext } from 'components/CommunityContext';
import { useChatContext } from 'components/new/chat/providers/ChatProvider/ChatProvider';
import { useGlobalState } from 'components/new/providers/GlobalStateProvider';

import { SiteLogo } from './SiteLogo';
import * as css from './SiteNav.css';
import SiteNavMenuItem from './SiteNavMenuItem';

export const SiteNav = () => {
  const { t } = useTranslation();
  const router = useRouter();
  const { featureFlags, currentUser, community } = useCommunityContext();
  const { isDirectMessagingEnabled, hasUnreadMessages, conversations } = useChatContext();
  const { lastConversationId } = useGlobalState();
  const showDirectMessaging =
    featureFlags['feature.communities-direct-messaging'] &&
    (isAdmin(currentUser) || isDirectMessagingEnabled);

  return (
    <nav className={css.sidebar}>
      <div className={css.container} data-qa="sidebar">
        <ul className={css.navList}>
          <li>
            <SiteLogo />
          </li>

          <SiteNavMenuItem
            active={!Object.values(pathnames.directMessaging).includes(router.pathname)}
            icon={UsersThree}
            label={t('site-nav_communities', 'Community')}
            onClick={() => goToHome(router, community.id)}
          />

          {showDirectMessaging && (
            <SiteNavMenuItem
              active={Object.values(pathnames.directMessaging).includes(router.pathname)}
              icon={ChatsCircle}
              label={t('pages-conversations_title', 'DMs')}
              statusIndicator={
                hasUnreadMessages ? (
                  <div className={css.indicator} data-qa="unread-messages-indicator" />
                ) : null
              }
              onClick={() => {
                const conversationId = lastConversationId || conversations[0]?.id || null;
                if (isDirectMessagingEnabled && conversationId) {
                  goToConversation(router, community.id, conversationId);
                } else {
                  goToConversations(router, community.id);
                }
              }}
            />
          )}
        </ul>
      </div>
    </nav>
  );
};

export default SiteNav;
